import { useIntl } from "gatsby-plugin-intl";
import config from "../../gatsby-config"

function detectLanguage() {
  let lang = '';

  if (typeof localStorage !== "undefined") {
    if (!!localStorage.getItem("mainLanguage")) {
      lang = localStorage.getItem("mainLanguage");
    }   else {
      lang = (typeof window !== "undefined") && window.navigator.language && window.navigator.language.split("-")[0]
    }

    localStorage.setItem('mainLanguage', lang);
  }

  return lang;
}

function CurrentLocale() {
  const intl = useIntl();
  return !!intl && !!intl.locale && intl.locale || 'en';
}

function DefaultLocale() {
  let defaultLocale = null;

  config.plugins.forEach(item => {
    if (item.resolve !== "gatsby-plugin-intl") {
      return;
    }

    if (!item.options || !item.options.defaultLanguage) {
      return;
    }

    defaultLocale = item.options.defaultLanguage;
  });

  return defaultLocale;
}

function LocaleList() {
  const defaultLanguage = DefaultLocale();
  let localeList = [];

  config.plugins.forEach(item => {
    if (item.resolve !== "gatsby-plugin-intl") {
      return;
    }

    if (!item.options || !item.options.languages) {
      return;
    }

    let languages = item.options.languages;

    localeList = languages.map(lang => {
      // Current location
      let path = "";
      let query = "";

      if (typeof document !== "undefined") {
        path = document.location.pathname;
        query = document.location.search;
      }

      path = path.replace(/^\/|\/$/g, ''); // trim slashes
      let pathParts = path.split(/\//g);

      // Check for existing lang in the path
      if (pathParts.length > 0 && languages.indexOf(pathParts[0]) !== -1) {
        pathParts = pathParts.slice(1);
      }

      let prefix = lang === defaultLanguage ? "/" : `/${lang}/`;

      return {
        lang,
        location: prefix.replace(/\/\//g, "/"),
        currentLocation: (prefix + pathParts.join("/") + "/" + query).replace(/\/\//g, "/")
      }
    });
  });

  return localeList;
}

function LinkPrefix() {
  let mapLanguages = !!LocaleList().length && LocaleList().map((item) => item.lang);

  const defaultLanguage = DefaultLocale();
  const currentLanguage = !!mapLanguages.length && mapLanguages.includes(detectLanguage()) ? detectLanguage() : defaultLanguage;

  return currentLanguage === defaultLanguage ? "/" : `/${currentLanguage}/`;
}

function LocaleLink(url) {
  return (LinkPrefix() + url).replace(/\/+/gi, "/");
}

function daysInMonth(month, year) {
  switch (month) {
      case 1: // January
      case 3: // March
      case 5: // May
      case 7: // July
      case 8: // August
      case 10: // October
      case 12: // December
          return 31;
      case 4: // April
      case 6: // June
      case 9: // September
      case 11: // November
          return 30;
      case 2: // February
          return !!year && (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28;
      default:
          return -1; // Invalid month
  }
}

function createDateArray(month, year) {
  return Array.from({ length: daysInMonth(month, year) }, (_, i) =>  i + 1);
}

function createMonthArray(lang) {
  return Array.from({ length: 12 }, (_, i) => new Date(0, i).toLocaleString(lang, { month: 'long' }));
}

function createYearArray(startYear, endYear) {
  return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
}

export {
  CurrentLocale,
  DefaultLocale,
  LocaleList,
  LinkPrefix,
  LocaleLink,
  createDateArray,
  createMonthArray,
  createYearArray
}
